import React from 'react';
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router-dom';
import NoData from '../shared/noDataComponent';
import { badge } from 'src/utils/statusColorsCode';

const NumericValue = ({ value, suffix = '', currency = '' }) => (
  <>
    <NumericFormat
      value={value || 0}
      decimalScale={2}
      thousandSeparator
      thousandsGroupStyle="lakh"
      displayType="text"
    />
    {suffix && ` ${suffix}`}
    {currency && ` ${currency}`}
  </>
);
const ImageSection = ({ item }) => {
  const imageUrl = item?.image || "https://digibankstoragespace.blob.core.windows.net/images/admindefault-card.png";
  const programId = item?.programId || '';
  return (
    <div className="px-0 py-2">
      <div className="relative xl:min-h-[235px] xl:max-h-[235px] xl:w-[424px] lg:w-[300px] lg:min-h-[186px] lg:max-h-[186px]">
        <img
          className="program-grid-img object-cover rounded-2xl w-full cursor-pointer xl:min-h-[235px] xl:max-h-[235px] xl:w-[424px] lg:w-[300px] lg:min-h-[186px] lg:max-h-[186px]"
          src={imageUrl}
          alt="Program"
        />
        <div className="mb-4 absolute top-0 left-0 h-full w-full p-4 flex flex-col justify-between cursor-pointer">
          <div />
          <p
            className="text-2xl font-semibold text-textWhite text-left"
            style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}
          >
            {`${programId.substring(0, 8)}....${programId.slice(-8)}`}
          </p>
          <span className={`${item?.cardType === 'Physical' ? 'physical-badge' : 'virtual-badge'} mb-4`}>
            {item?.cardType}
          </span>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-xs font-normal mb-0 text-textWhite">Currency</p>
              <p className="md:text-md text-base font-semibold mb-0 text-textWhite">{item?.cardCurrency}</p>
            </div>
            <div>
              <p className="text-xs font-normal mb-0 text-textWhite">Bin</p>
              <p className="md:text-md text-base font-semibold mb-0 text-textWhite">{item?.bin || ''}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const DetailGrid = ({ item }) => (
  <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-2 gap-6">
    <InfoBlock label="Creation Fee">
      <NumericValue value={item?.cardCreationFee} currency={item?.cardCurrency} />
    </InfoBlock>
    <InfoBlock label="Recharge Fee (%)">
      <NumericValue value={item?.rechargeFee} suffix="%" />
    </InfoBlock>
    <InfoBlock label="Recharge Amount">
      <NumericValue value={item?.rechargeMin} />
      {(item?.rechargeMin && item?.rechargeMax) && " - "}
      <NumericValue value={item?.rechargeMax} currency={item?.cardCurrency} />
    </InfoBlock>
    {item?.cardType === 'Physical' && (
      <InfoBlock label="ATM Withdrawal Fee">
        <NumericValue value={item?.atmWithdrawlFee} suffix="%" />
      </InfoBlock>
    )}
    <InfoBlock label="Cancellation Fee">
      <NumericValue value={item?.cardCancellationMinFee} currency={item?.cardCurrency} />
      {" - "}
      <NumericValue value={item?.cardCancellationMaxFee} suffix="%" />
    </InfoBlock>
    <InfoBlock label="Status">
      <span className={`status-badge ${badge[item?.status?.toLowerCase()] || 'bg-green'}`}>
        {item?.status}
      </span>
    </InfoBlock>
  </div>
);
const InfoBlock = ({ label, children }) => (
  <div className="text-left">
    <span className="text-labelGrey block">{label}</span>
    <p className="summary-value !w-auto">{children}</p>
  </div>
);
const ProgramsGridBar = ({ data }) => {
  const navigate = useNavigate();
  const handleDetailsClick = (item) => {
    window.scrollTo(0, 0);
    navigate(`/services/cardDetails/${item?.id}/${item?.name}`);
  };
  if (!data?.length) {
    return (
      <div className="chart-nodata">
        <span>
          <NoData />
        </span>
      </div>
    );
  }
  return (
    <div className="w-full program-card">
      {data.map((item) => (
        <button
          key={item?.id}
          className="w-full hover:bg-kendotdBghover border border-StrokeColor border-l-0 border-r-0 xl:flex md:block items-start gap-6"
          onClick={() => handleDetailsClick(item)}
        >
          <ImageSection item={item} />
          <div className="md:flex-1 px-0 py-2 cursor-pointer w-full rounded-r-5">
            <h4 className="md:text-2xl text-base font-semibold m-0 text-darkWhite uppercase text-left md:mb-6 mb-4">
              {item?.name}
            </h4>
            <DetailGrid item={item} />
          </div>
        </button>
      ))}
    </div>
  );
};
export default ProgramsGridBar;
